<h6 class="head head6">Netwerk</h6>

<section class="settings-section mb-5">
	<input id="wifi" name="network" type="radio" [(ngModel)]="network" value='wifi'>
	<label class="wifi-label four col" for="wifi">Wifi</label>

	<input id="no-wifi" name="network" type="radio" [(ngModel)]="network" value='mobile'>
	<label class="no-wifi-label four col" for="no-wifi">4/5 G</label>
</section>

<h6 class="head head6">Tijdweergave foto's</h6>

<section class="settings-section mb-5">
	<input id="timestamp-true" name="timestamp" type="radio" [(ngModel)]="displayTimestamp" [value]="true">
	<label class="four col" for="timestamp-true">Aan</label>

	<input id="timestamp-false" name="timestamp" type="radio" [(ngModel)]="displayTimestamp" [value]="false">
	<label class="four col" for="timestamp-false">Uit</label>
</section>

<h6 class="head head6">Vestiging</h6>

<mat-form-field class="w-100 mb-5">
	<mat-select name="residenceCode" [(ngModel)]="residence.code">
		<mat-option *ngFor="let residence of residences" [value]="residence.code">
			{{residence.displayName}}
		</mat-option>
	</mat-select>
</mat-form-field>

<div class="settings-section section-buttons">
	<a routerLink="/" class="btn md btn-cinna">
		<span>Annuleren</span>
	</a>

	<button type="button" class="btn md btn-save" (click)="saveSettings()">
		<span>Opslaan</span>
	</button>
</div>
